export default {
  dashboardReports: {
    appDataReports: "Relatório de Dados",
    reports: "Relatórios",
    soilNutrients: {
      carbon: "Carbono",
      potassium: "Potássio",
      phosphorus: "Fósforo",
      nitrogen: "Nitrogênio",
      sulfur: "Enxofre",
    },
  },
  dashboardSection: {
    greenBeansData: "Gestão de Feijão Verde",
    greenCoffee: "Café Verde",
    dryMilling: "Moagem a Seco",
    modules: "Módulos",
    allowances: "Subsídios",
    maxUserAllowed: "Máximo de usuários permitidos ",
    satelliteReportsAllowed: "Relatórios de satélite permitidos ",
    advanceReport: "Relatórios avançados permitidos",
    subscriptionUpTo: "Assinatura até",
    roleAllowed: "Funções permitidas ",
    moduleAllowed: "Módulos permitidos ",
    registeredUsers: "Usuários registrados",
    validMemberships: "Assinaturas válidas",
    activeUsers: "Usuários ativos",
    deactivatedUsers: "Usuários desativados",
    membershipValidity: "Validade da assinatura",
    lessThan1Month: "Menos de 1 mês",
    months1to6: "1-6 meses",
    months6to12: "6-12 meses",
    moreThan1Year: "Mais de 1 ano",
    cropOverview: "Visão geral do Cultivo",
    plantations: "Plantações ",
    coffeeData: "Dados do café",
    availableModules: "Módulos disponíveis",
    roleList: "Agricultor, Estação de Coleta, Armazém",
    memberData: "Dados de Membro",
    userType: "Tipo de Usuário",
    registered: "Registrado",
    offlineUsers: "Usuários Offline",
    lessThanOneMonth: "< 1 Mês",
    cacaoData: "Dados de Cacau",
    dryCacao: "Cacau Seco",
    traceability: "Rastreabilidade",
    allFarm: "Todas as Fazendas",
  },
  greenBeansData: {
    notFound: "Nenhum dado encontrado",
  },
  dashboardV2: {
    usersByStatus: "Usuários por Status",
    allTime: "Todos os Tempos",
    noOfUsers: "Nº de Usuários",
    usersByGender: "Usuários por Gênero",
    gender: "Gênero",
    farmerName: "Nome do Agricultor",
    farmerProduction: "Produção do Agricultor",
    production: "Produção",
    plan: "Plano",
    expiryDate: "Data de Expiração",
    buyingStationProduction: "Produção da Estação de Compra",
    dryMillingProduction: "Produção de Moagem a Seco",
    usersPerMembershipPlans: "Usuários por Planos de Assinatura",
    planType: "Tipo de Plano",
    users: "Usuários",
    planValidity: "Validade dos Planos",
    averageSellingPriceByAllFarmers:
      "Preço Médio de Venda por Todos os Agricultores",
    avgSellingPrice: "Preço Médio de Venda",
    pricePaid: "Preço Pago",
    avgSellingPricePerFarmer: "Preço Médio de Venda por Agricultor",
    exportAsCSV: "Exportar como CSV",
    exportAsXLS: "Exportar como XLS",
  },
}